import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../_shared';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: [
    '../../assets/css/core-navbar.css',
    '../navbar/navbar.component.css',
    './notifications.component.css'
  ]
})
export class NotificationsComponent implements OnInit {
  constructor(private loadingService: LoadingService) { }

  ngOnInit() {
    this.load(false);
  }

  load(value: boolean) {
    this.loadingService.setLoadingState(value);
  }
}



// WEBPACK FOOTER //
// D:/Work-Local/frontend/src/app/notifications/notifications.component.ts